import { useState, useEffect } from "react";
import { styles } from "./style";
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@/common/styles/style";
import { getUtcOffset } from "@/helpers/getUtcOffset";
import { testTimezone } from "@/common/data/timezone";

interface TimeZoneSelectProps {
  value?: number;
  onChange: (value: number) => void;
}

export default function TimeZoneSelect({
  value,
  onChange,
}: TimeZoneSelectProps) {
  const [availableTimeZones, setAvailableTimeZones] = useState<
    { id: number; zone: string; label: string }[]
  >([]);
  const [selectedValue, setSelectedValue] = useState<number | "">("");

  useEffect(() => {
    const timeZonesWithOffset = testTimezone.map(({ id, zone, name }) => ({
      id,
      zone,
      label: zone !== "UTC" ? `${name} (${zone}, ${getUtcOffset(zone)})` : `${name} (UTC)`,
    }));
    setAvailableTimeZones(timeZonesWithOffset);
  }, []);

  useEffect(() => {
    if (value || value === 0) {
      setSelectedValue(value);
    } else {
      setSelectedValue("");
    }
  }, [value]);

  const handleChange = (event: SelectChangeEvent<number>) => {
    const newValue = event.target.value;
    const validValue = newValue === 0 ? 0 : newValue;
    setSelectedValue(validValue as number);
    if (onChange) {
      onChange(validValue as number);
    }
  };

  return (
    <Box sx={styles.container}>
      <Select
        value={selectedValue}
        onChange={handleChange}
        size="small"
        fullWidth
        sx={styles.input}
        displayEmpty
      >
        <MenuItem value={0} disabled>選択してください</MenuItem>
        {availableTimeZones.map(({ id, label }) => (
          <MenuItem key={id} value={String(id)}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
